/* eslint-disable no-unused-vars */

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Card, Divider, Grid, Typography, Button, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';

// project imports
import { BASE_PATH } from 'config';
import { gridSpacing } from 'store/constant';

// assets
import { IconTallymark1 } from '@tabler/icons';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import HomeIcon from '@mui/icons-material/Home';
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';

const linkSX = {
    display: 'flex',
    color: 'grey.900',
    textDecoration: 'none',
    alignContent: 'center',
    alignItems: 'center'
};

// ==============================|| BREADCRUMBS ||============================== //

const Breadcrumbs = ({ card, divider, icon, icons, maxItems, navigation, rightAlign, separator, title, titleBottom, formRules, ...others }) => {
    const theme = useTheme();

    const iconStyle = {
        marginRight: theme.spacing(0.75),
        marginTop: `-${theme.spacing(0.25)}`,
        width: '16px',
        height: '16px',
        color: theme.palette.secondary.main
    };

    const [main, setMain] = useState();
    const [item, setItem] = useState();
    const [rulesWindowOpen, setRulesWindowOpen] = useState(false);
    // set active item state
    const getCollapse = (menu) => {
        if (menu.children) {
            menu.children.filter((collapse) => {
                if (collapse.type && collapse.type === 'collapse') {
                    getCollapse(collapse);
                } else if (collapse.type && collapse.type === 'item') {
                    if (document.location.pathname === BASE_PATH + collapse.url) {
                        setMain(menu);
                        setItem(collapse);
                    }
                }
                return false;
            });
        }
    };

    useEffect(() => {
        navigation?.items?.map((menu) => {
            if (menu.type && menu.type === 'group') {
                if (menu?.url && BASE_PATH + menu.url === document.location.pathname) {
                    setMain(menu);
                    setItem(menu);
                } else {
                    getCollapse(menu);
                }
            }
            return false;
        });
    });

    // item separator
    const SeparatorIcon = separator;
    const separatorIcon = separator ? <SeparatorIcon stroke={1.5} size="16px" /> : <IconTallymark1 stroke={1.5} size="16px" />;

    let mainContent;
    let itemContent;
    let breadcrumbContent = <Typography />;
    let itemTitle = '';
    let CollapseIcon;
    let ItemIcon;

    // collapse item
    if (main && main.type === 'collapse') {
        CollapseIcon = main.icon ? main.icon : AccountTreeTwoToneIcon;
        mainContent = (
            <Typography component={Link} to="#" variant="subtitle1" sx={linkSX}>
                {icons && <CollapseIcon style={iconStyle} />}
                {main.title}
            </Typography>
        );
    }

    // items
    if ((item && item.type === 'item') || (item?.type === 'group' && item?.url)) {
        itemTitle = item.title;

        ItemIcon = item.icon ? item.icon : AccountTreeTwoToneIcon;
        itemContent = (
            <Typography
                variant="subtitle1"
                sx={{
                    display: 'flex',
                    textDecoration: 'none',
                    alignContent: 'center',
                    alignItems: 'center',
                    color: 'grey.500'
                }}
            >
                {icons && <ItemIcon style={iconStyle} />}
                {itemTitle}
                <Button onClick={() => { setRulesWindowOpen(true) }}>[Form Rules]</Button>
            </Typography>
        );

        // main
        if (item.breadcrumbs !== false) {
            breadcrumbContent = (
                <>
                    <Card
                        sx={{
                            // marginBottom: card === false ? 0 : 1,
                            // theme.spacing(gridSpacing),
                            // border: card === false ? 'none' : '1px solid',
                            // borderColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.primary[200] + 75,
                            background: 'transparent'
                            // card === false ? 'transparent' : theme.palette.background.default
                        }}
                        {...others}
                    >
                        <Box sx={{ p: 0, pl: card === false ? 0 : 2 }}>
                            <Grid
                                container
                                direction={rightAlign ? 'row' : 'column'}
                                justifyContent={rightAlign ? 'space-between' : 'flex-start'}
                                alignItems={rightAlign ? 'center' : 'flex-start'}
                                spacing={1}
                            >
                                {/* {title && !titleBottom && (
                                <Grid item>
                                    <Typography variant="h3" sx={{ fontWeight: 500 }}>
                                        {item.title}
                                    </Typography>
                                </Grid>
                            )} */}
                                <Grid item>
                                    <MuiBreadcrumbs
                                        sx={{ '& .MuiBreadcrumbs-separator': { width: 16, ml: 1.25, mr: 1.25 } }}
                                        aria-label="breadcrumb"
                                        maxItems={maxItems || 8}
                                        separator={separatorIcon}
                                    >
                                        <Typography component={Link} to="/" color="inherit" variant="subtitle1" sx={linkSX} aria-label="home">
                                            {icons && <HomeTwoToneIcon sx={iconStyle} />}
                                            {icon && <HomeIcon sx={{ ...iconStyle, mr: 0 }} />}
                                            {!icon && 'Staff Dashboard'}
                                        </Typography>
                                        {mainContent}
                                        {item?.url === '/dashboard' ? null : itemContent}
                                    </MuiBreadcrumbs>
                                </Grid>
                                {title && titleBottom && (
                                    <Grid item>
                                        <Typography variant="h3" sx={{ fontWeight: 500 }}>
                                            {item.title}
                                        </Typography>
                                    </Grid>
                                )}
                            </Grid>
                        </Box>
                        {card === false && divider !== false && <Divider sx={{ borderColor: theme.palette.primary.main, mb: gridSpacing }} />}
                    </Card>
                    <Dialog
                        open={rulesWindowOpen}
                        onClose={() => setRulesWindowOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        {rulesWindowOpen && (
                            <>
                                <DialogTitle id="alert-dialog-title">
                                    {'Form rules for this page'}
                                </DialogTitle>
                                <DialogContent>
                                    {formRules?.length > 0 ? formRules?.map((rule, index) => (
                                        <Typography variant="body2" key={index} sx={{ mb: 2 }}>
                                            <strong>Rule {index + 1}:</strong> {rule.rule}
                                        </Typography>
                                    )) : <Typography variant="body2" sx={{ mb: 2 }}>
                                            No form rules available.
                                        </Typography>}
                                </DialogContent>
                                <DialogActions>
                                    <Button variant="contained" size="small" onClick={() => setRulesWindowOpen(false)}>
                                        Close
                                    </Button>
                                </DialogActions>
                            </>
                        )}
                    </Dialog>
                </>
            );
        }
    }

    return breadcrumbContent;
};

Breadcrumbs.propTypes = {
    card: PropTypes.bool,
    divider: PropTypes.bool,
    icon: PropTypes.bool,
    icons: PropTypes.bool,
    maxItems: PropTypes.number,
    navigation: PropTypes.object,
    rightAlign: PropTypes.bool,
    separator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    title: PropTypes.bool,
    titleBottom: PropTypes.bool
};

export default Breadcrumbs;
